import React from "react";
import { Link } from "react-router-dom";
import musicClassification3D from "../assets/music-classification-3d.png";

const StakeholderCallout: React.FC = () => {
  const stakeholders = [
    {
      icon: (
        <div className="relative">
          <div className="relative p-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#55b3f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
        </div>
      ),
      title: "Legal & Copyright Offices",
      description: "Validate AI music copyright claims with regulatory compliance frameworks",
      gradient: "from-blue-500 to-purple-600"
    },
    {
      icon: (
        <div className="relative">
          <div className="relative p-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#55b3f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <circle cx="9" cy="9" r="2" />
              <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
            </svg>
          </div>
        </div>
      ),
      title: "Rightsholders, CMOs, PROs & Distributors",
      description: "Clear AI intentional usage reporting & validation systems",
      gradient: "from-cyan-500 to-blue-600"
    },
    {
      icon: (
        <div className="relative">
          <div className="relative p-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#55b3f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 3v18h18" />
              <path d="m19 9-5 5-4-4-3 3" />
            </svg>
          </div>
        </div>
      ),
      title: "AI companies, DAWs & Studio Equipment",
      description: "Ethical AI music tools that ensure clear legal AI generation compliance",
      gradient: "from-indigo-500 to-purple-600"
    },
  ];

  return (
    <div className="relative py-24 bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-100 overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10 bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${musicClassification3D})` }}
      />
      
      {/* Floating shapes */}
      <div className="absolute top-10 right-10 w-24 h-24 bg-tagblue/10 rounded-full blur-xl animate-float" />
      <div className="absolute bottom-10 left-10 w-32 h-32 bg-tagblue-light/10 rounded-full blur-xl animate-float" style={{ animationDelay: '3s' }} />
      
      <div className="relative container mx-auto px-6 md:px-8 lg:px-12">
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900 mb-4">
            Calling all AI-Human Copyright stakeholders!
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            We are trying to bridge the gap by gathering inputs from whole Industry. We intend to give-away core of Copyrightability Engine as a Non-Profit!
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {stakeholders.map((stakeholder, index) => (
            <div 
              key={index} 
              className="group relative"
            >
              {/* Card glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-tagblue to-tagblue-light rounded-3xl blur-2xl opacity-25 group-hover:opacity-50 transition-opacity duration-500" />
              
              {/* Main card */}
              <div className="relative bg-white/80 backdrop-blur-md rounded-3xl p-10 text-center shadow-xl hover:shadow-2xl transition-all duration-500 border border-white/50 group-hover:scale-105 transform">
                <div className="flex justify-center mb-8 animate-float" style={{ animationDelay: `${index * 0.5}s` }}>
                  {stakeholder.icon}
                </div>
                
                <h3 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">
                  {stakeholder.title}
                </h3>
                
                <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                  {stakeholder.description}
                </p>
                
                {/* Decorative bottom accent */}
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gradient-to-r from-tagblue to-tagblue-light rounded-full opacity-60" />
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link 
            to="/contact"
            className="bg-tagblue text-white px-8 py-4 rounded-xl hover:bg-tagblue-dark transition-colors font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};
export default StakeholderCallout;